export const loadScript = (attrs: object): void => {
  const script: HTMLScriptElement = document.createElement('script');
  script.type = 'text/javascript';
  Object.keys(attrs).forEach((key) => {
    script[key] = attrs[key];
  });
  document.head.appendChild(script);
};

export const toExternalScript = (src: string): string =>
  `<script src="${src}"></script>`;
